// Auto-generated by devextreme-license.
// Do not commit this file to source control.

export const licenseKey = 'LCPv137c137,g>o!6Sbd>,yVV%%fL(eaF>_yf9<mF!Y,f>y,4:+,@p>3@,<,NIQ@ESn,>VNSdSQRKVRdeZj94%etLSb+F%oRvS%yvV_,z%Jt+%>dtcHaXZKF$!N:4!otF7Qm1,J8[9%e$c<Ey7<@$p_-tcN:n(<+;7<LoIb<o%n+((QEn>He7,RQmki-<2%d)6i-)6_@E%%d!67@@IbR:!QtF>Qt<pL!E6<4$>%X<2p@6p<-)!jyQaNRQpg!F6<4$27y@G<-6p<dQI%!:aQ!)27@QI%4v>jzvaj@F2%d6Ig!:6_@$9j@:>Q4:G_@@9Qdv6<!F6<dFI7yFI7yFI7Ll';
